// Generated by BUCKLESCRIPT VERSION 4.0.7, PLEASE EDIT WITH CARE

import * as BigJs from "big.js";

function percent(str) {
  return BigJs.Big(str).div(BigJs.Big("100")).toPrecision();
}

function $$eval(x, op, y) {
  switch (op) {
    case 0 : 
        return BigJs.Big(x).plus(BigJs.Big(y));
    case 1 : 
        return BigJs.Big(x).minus(BigJs.Big(y));
    case 2 : 
        return BigJs.Big(x).times(BigJs.Big(y));
    case 3 : 
        if (y !== "0") {
          return BigJs.Big(x).div(BigJs.Big(y));
        } else {
          return BigJs.Big(x);
        }
    
  }
}

function evalValue(x, op, y) {
  return $$eval(x, op, y).toPrecision();
}

export {
  percent ,
  $$eval ,
  evalValue ,
  
}
/* big.js Not a pure module */
